"use client"

import {
  InfiniteTable,
  TableSkeleton,
} from "@/app/components/infinite-table/infinite-table"
import { HeaderRow } from "@/app/components/table"
import type { Activity } from "@anaconda/core/activity/types"
import { TableRow } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { Cell } from "./cells"
import { COLUMNS } from "./columns"
import { useActivityItemsReatom as useActivityItems } from "./use-activity-items.reatom"

const COMPONENTS = {
  HeaderRow: NftHeaderRow,
  RowContent,
  RowSkeleton,
  TableRow: (props: React.ComponentProps<typeof TableRow>) => {
    return <TableRow {...props} data-testid="nft-activity" />
  },
} as const

const getItemKey = (item: Activity) => item.id

export const NftActivityTable = reatomComponent(() => {
  const { items, loadNext } = useActivityItems()

  return (
    <InfiniteTable
      getItemKey={getItemKey}
      items={items}
      loadNext={loadNext}
      components={COMPONENTS}
      useWindowScroll={false}
      initialItemCount={15}
    />
  )
}, "NftActivityTable")

export function NftActivityTableSkeleton() {
  return <TableSkeleton HeaderRow={NftHeaderRow} RowSkeleton={RowSkeleton} />
}

function NftHeaderRow() {
  return (
    <HeaderRow>
      {COLUMNS.map((column, index) => (
        <column.Header key={index} />
      ))}
    </HeaderRow>
  )
}

function RowContent({ content }: { content: Activity }) {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <column.Content key={index} {...content} />
      ))}
    </>
  )
}

function RowSkeleton() {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Skeleton />
        </Cell>
      ))}
    </>
  )
}
